import { render, staticRenderFns } from "./approvalIncident.vue?vue&type=template&id=ba7cc90c&scoped=true"
import script from "./approvalIncident.vue?vue&type=script&lang=js"
export * from "./approvalIncident.vue?vue&type=script&lang=js"
import style0 from "./approvalIncident.vue?vue&type=style&index=0&id=ba7cc90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7cc90c",
  null
  
)

export default component.exports